<template>
  <div v-if="contents.status">
    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl my-5">
      <!--begin::Hero card-->
      <div class="card mb-12 shadow-sm">
        <!--begin::Hero body-->
        <div class="card-body flex-column p-5 mb-5">
          <!--begin::Hero content-->
          <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center h-lg-300px p-5 p-lg-15 overlay-wrapper gap-10"
          >
            <!--begin::Wrapper-->
            <div
              class="d-flex flex-column align-items-start justift-content-center flex-equal me-5 order-1 order-md-0"
            >
              <!--begin::Title-->
              <h1 class="fw-bolder fs-4 fs-lg-1 text-gray-800 mb-5 mb-lg-5">
                {{ contents.data.page.locale.title }}
              </h1>
              <!--end::Title-->
              <!--begin::Input group-->
              <div class="position-relative w-100 mb-5 mb-lg-10">
                <span class="text-gray-600 fs-6">{{
                  contents.data.page.locale.subTitle
                }}</span>
              </div>
              <!--end::Input group-->
              <!--begin::Action-->
              <a
                href="#"
                class="btn btn-primary fw-bolder fs-5"
                @click="setModalConfigs('create')"
                ><i
                  class="me-2 fs-4"
                  :class="`${contents.data.page.setting.buttonIcon}`"
                ></i
                >{{ contents.data.page.locale.buttonLabel }}</a
              >
              <!--end::Action-->
            </div>
            <!--end::Wrapper-->
            <!--begin::Wrapper-->
            <div
              class="flex-equal d-flex align-self-center justify-content-end align-items-center order-0 order-md-1"
            >
              <!--begin::Illustration-->
              <img
                :src="`${backendHost}/images/themes/${contentTheme}/${
                  $store.state.sidebar[contents.name].routeImage
                }`"
                alt=""
                class="mw-100 min-h-200px mh-325px"
              />
              <!--end::Illustration-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Hero content-->
        </div>
        <!--end::Hero body-->
      </div>
      <!--end::Hero card-->
      <div v-if="dataIsEmpty" class="card-body p-20">
        <div class="d-flex flex-center">
          <img
            class="col-md-3"
            :src="`/assets/images/svg/no_data.svg`"
            alt=""
          />
        </div>
      </div>
      <!--begin::Row-->
      <div v-else>
        <!--begin::Col-->
        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9">
          <div
            v-for="(post, index) in posts"
            :key="index"
            class="col d-flex align-items-stretch"
          >
            <!--begin::Card-->
            <div class="card w-100">
              <!--begin::Card body-->
              <div class="card-body pb-0 d-flex flex-column">
                <div class="mb-6 d-flex flex-stack">
                  <!-- <a
                    href="#"
                    class="text-primary bg-light-primary text-hover-inverse-secondary bg-hover-secondary rounded fw-bold p-2 fs-8 me-2"
                    >{{ post.tagName }}</a
                  > -->
                  <div class="row m-0 p-0 g-0 justify-content-center">
                    <a v-for="tag in post.postTagsName"
                      :key="tag.id"
                      :href="`#${tag.id}`"
                      class="col text-inverse-light bg-light text-hover-inverse-secondary bg-hover-secondary rounded fw-bold p-2 fs-8 text-center"
                      >{{ tag.label }}</a
                    >
                  </div>
                </div>
                <!--begin::Image-->
                <div class="d-flex justify-content-center mb-5">
                  <div
                    class="symbol symbol-200px"
                    style="background-color: #cccc"
                  >
                    <img
                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${post.postPhoto[0]}`"
                      class="d-block card-image img w-100"
                      :alt="`${post.postPhoto[0]}`"
                    />
                  </div>
                  <!-- <div
                    :id="`carouselExampleIndicators${index}`"
                    class="carousel slide"
                    data-bs-ride="carousel"
                  >
                    <div class="carousel-indicators">
                      <button
                        v-for="(photo, bid) in post.postPhoto"
                        :key="bid"
                        type="button"
                        :data-bs-target="`#carouselExampleIndicators${index}`"
                        :data-bs-slide-to="`${bid}`"
                        :class="bid == 0 ? `active` : ''"
                        :aria-current="bid == 0 ? true : null"
                        :aria-label="`Slide ${Number(bid) + 1}`"
                      ></button>
                    </div>
                    <div class="carousel-inner">
                      <div
                        v-for="(photo, pid) in post.postPhotos"
                        :key="photo"
                        class="carousel-item"
                        :class="pid == 0 ? 'active' : ''"
                      >
                        <div
                          class="symbol symbol-200px"
                          style="background-color: #cccc"
                        >
                          <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                            class="d-block card-image img w-100"
                            :alt="`${photo}`"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      class="carousel-control-prev"
                      type="button"
                      :data-bs-target="`#carouselExampleIndicators${index}`"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button
                      class="carousel-control-next"
                      type="button"
                      :data-bs-target="`#carouselExampleIndicators${index}`"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div> -->
                </div>
                <!--end::Image-->
                <!--begin::Title-->
                <a
                  :href="`${backendHost}/shop/r/${post.id}?locale=${routeLocale}`"
                  class="fs-4 text-gray-800 text-hover-primary fw-bold mb-1"
                  target="_blank"
                  >{{ post.postTitle }}</a
                >
                <!--begin::Summary-->
                <div
                  class="text-gray-500 mb-3 text_justify fs-7"
                  v-html="post.postDescription"
                ></div>
                <!--end::Summary-->
                <!--end::Title-->
                <!--begin::Position-->
                <div class="d-flex flex-stack mb-3">
                  <div class="text-gray-500">
                    <i class="bi bi-calendar me-1"> </i>
                    {{ post.postDate }}
                  </div>
                </div>
                <!--end::Position-->
              </div>
              <div class="card-footer py-3 d-flex flex-column">
                <div class="d-flex flex-stack justify-content-center mb-5">
                  <a class="btn btn-primary fs-8" @click="setModalConfigs('update', index)"> Edit </a>
                  <button class="ms-2 btn btn-danger fs-8" @click="setModalConfigs('delete', index)">Delete</button>
                </div>
                <div class="align-self-center">
                  <!-- <a
                    :href="`/role-view?id=${post.id}`"
                    class="btn btn-sm btn-light btn-active-primary my-1 me-2"
                    >{{ contents.data.page.card.buttons[0].label }}</a
                  > -->
                  <!-- <button
                    type="button"
                    class="btn btn-sm btn-light btn-active-light-primary my-1 me-2"
                    @click="setModalConfigs('update', index)"
                  >
                    {{ contents.data.page.card.buttons[1].label }}
                  </button> -->
                  <!-- <button
                    type="button"
                    class="btn btn-sm btn-light btn-active-light-danger my-1"
                    data-bs-toggle="modal"
                    data-bs-target="#kt_modal_update_role"
                    @click="setModalConfigs('delete', index)"
                  >
                    {{ contents.data.page.card.buttons[2].label }}
                  </button> -->
                </div>
              </div>
              <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
        </div>
        <div v-if="totalPages > 1" class="w-100 text-center mt-5">
          <pagination
            :pages="totalPages"
            v-model="currentPage"
            @update:modelValue="setCurrentPage"
          ></pagination>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->
      <!--begin::Modals-->
      <create-update
        v-if="modalDisplay"
        :contents="contents.data.modal"
        :modalInfo="postInfo"
        :mode="mode"
        :modalType="'uploadselect'"
        :firstErrorName="firstErrorName"
        @close-modal="setModalConfigs"
      ></create-update>
      <dialog-box
        v-if="dialogDisplay"
        :contents="contents.data.modal"
        :modalInfo="deleteInfo"
        @close-modal="setModalConfigs"
      >
      </dialog-box>
      <!--end::Modals-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import dataService from '../../../services/data';
import serverConfigs from '../../../configs/server.json';

// Tools
import Pagination from '../../tools/Pagination.vue';

// Modals
import CreateUpdate from '../../modals/CreateUpdate.vue';
import DialogBox from '../../modals/DialogBox.vue';

export default {
  components: {
    Pagination,
    CreateUpdate,
    DialogBox,
  },
  setup() {},
  computed: {
    contentTheme() {
      return this.$store.state.themeFile.replace('.css', '');
    },
    backendHost() {
      return serverConfigs['serverDomain']['host'];
    },
    routeLocale() {
      return this.$route.params.locale;
    },
    bodyNode() {
      return document.getElementById('kt_body');
    },
  },
  data() {
    return {
      totalPages: 0,
      currentPage: 1,
      pac: false,
      postInfo: {},
      deleteInfo: Object,
      modalDisplay: false,
      dialogDisplay: false,
      dataIsEmpty: true,
      posts: [],
      firstErrorName: '',
      contents: {
        name: '',
        data: {},
        status: false,
      },
      mode: 'multi',
      loaderStatus: [false, false],
    };
  },
  methods: {
    setModalConfigs(opt, index) {
      this.$store.commit('setLoader', true);

      switch (opt) {
        case 'update':
          this.postInfo = { ...this.posts[index], status: false };
          this.postInfo['photos'] = this.posts[index].postPhotos;
          this.modalDisplay = !this.modalDisplay;
          this.$store.commit('setLoader', false);

          break;
        case 'create':
          this.setupPostInfo();
          this.modalDisplay = !this.modalDisplay;
          this.$store.commit('setLoader', false);

          break;
        case 'delete':
          this.deleteInfo = {
            id: this.posts[index].id,
            name: this.posts[index].postName,
            status: false,
            delete: true,
          };
          this.dialogDisplay = !this.dialogDisplay;
          this.$store.commit('setLoader', false);

          break;
        case 'validate':
          console.log(index)
          if (index.delete) {
            this.deletePosts(index);
          } else {
            // index["postPhotos"] = index["photos"];
            if (this.inputValidation(index)) {
              index.id ? this.updatePosts(index) : this.createPosts(index);
            } else {
              this.$store.commit('setLoader', false);
            }
          }
          break;
        default:
          this.resetPostInfo();
          this.$store.commit('setLoader', false);

          break;
      }
    },
    setCurrentPage(page) {
      this.$store.commit('setLoader', true);
      this.readPosts(page);
    },
    loaderDone() {
      if (
        this.loaderStatus[0] &&
        this.loaderStatus[1] &&
        this.loaderStatus[2]
      ) {
        this.$store.commit('setLoader', false);
      }
    },
    getContents() {
      let data = {
        endPoint: `contents/r/posts`,
        locale: `${this.routeLocale}`,
        data: {},
      };

      dataService
        .get(data)
        .then((res) => {
          this.contents = {
            name: res.data.data[0].contentName,
            data: res.data.data[0].contentJson,
            status: true,
          };
          // this.readCategories();
          this.readTags();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[0] = true;
          this.loaderDone();
        });
    },
    setupPostInfo() {
      let rootCard = {};
      let childCard = {};
      for (let counter in this.contents.data.modal.fields) {
        switch (this.contents.data.modal.fields[counter].type) {
          case 'text':
            this.postInfo[this.contents.data.modal.fields[counter].name] = '';
            break;
          case 'textarea':
            this.postInfo[this.contents.data.modal.fields[counter].name] = '';
            break;
          case 'card':
            Object.assign(
              rootCard,
              this.contents.data.modal.fields[counter].value
            );
            this.postInfo[this.contents.data.modal.fields[counter].name] = [
              rootCard,
            ];
            for (let i in this.contents.data.modal.fields[counter].fields) {
              switch (this.contents.data.modal.fields[counter].fields[i].type) {
                case 'text':
                  this.postInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = '';
                  break;
                case 'textarea':
                  this.postInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = '';
                  break;
                case 'card':
                  Object.assign(
                    childCard,
                    this.contents.data.modal.fields[counter].fields[i].value
                  );
                  this.postInfo[
                    this.contents.data.modal.fields[counter].fields[i].name
                  ] = [childCard];
                  break;
                default:
                  break;
              }
            }
            break;
          default:
            break;
        }
      }
      this.postInfo['status'] = true;
    },
    resetPostInfo() {
      this.postInfo = {};
      this.modalDisplay = false;
      this.dialogDisplay = false;
      if (!this.modalDisplay) {
        this.bodyNode.classList.remove('modal-open');
        this.bodyNode.style.overflow = 'visible';
      }
      for (let index in this.contents.data.modal.fields) {
        if (this.contents.data.modal.fields[index].required) {
          this.contents.data.modal.fields[index].errorCode = 0;
        }
      }
    },
    inputValidation(obj) {
      let errorCount = 0;
      let tempError = '';

      for (
        let index = 0;
        index < this.contents.data.modal.fields.length;
        index++
      ) {
        // if (this.contents.data.modal.fields[index].type == "card") {
        //   for (
        //     let i = 0;
        //     i < this.contents.data.modal.fields[index].fields.length;
        //     i++
        //   ) {
        //     for (let p in obj[this.contents.data.modal.fields[index].name]) {
        //       if (
        //         this.contents.data.modal.fields[index].fields[i].type == "card"
        //       ) {
        //         for (
        //           let j = 0;
        //           j <
        //           this.contents.data.modal.fields[index].fields[i].fields
        //             .length;
        //           j++
        //         ) {
        //           if (
        //             this.contents.data.modal.fields[index].fields[i].fields[j]
        //               .required
        //           ) {
        //             console.log(obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i].name
        //                   ])
        //                   console.log(this.contents.data.modal.fields[index].fields[i].name)
        //             // for (let s in obj[
        //             //   this.contents.data.modal.fields[index].fields[i].name
        //             // ]) {
        //             //   // for (let expression in this.contents.data.modal.fields[
        //             //   //   index
        //             //   // ].fields[i].fields[j].validation) {
        //             //   //   switch (
        //             //   //     this.contents.data.modal.fields[index].fields[i]
        //             //   //       .fields[j].validation[expression].expression
        //             //   //   ) {
        //             //   //     case "isEmpty":
        //             //   //       this.contents.data.modal.fields[index].fields[
        //             //   //         i
        //             //   //       ].fields[j].errorCode =
        //             //   //         !obj[this.contents.data.modal.fields[index].name][
        //             //   //           p
        //             //   //         ][
        //             //   //           this.contents.data.modal.fields[index].fields[i]
        //             //   //             .fields[j].name
        //             //   //         ][s] ||
        //             //   //         obj[this.contents.data.modal.fields[index].name][
        //             //   //           s
        //             //   //         ][
        //             //   //           this.contents.data.modal.fields[index].fields[i]
        //             //   //             .fields[j].name
        //             //   //         ].length == 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].validation[expression].id
        //             //   //           : 0;
        //             //   //       if (
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //       ) {
        //             //   //         errorCount += 1;
        //             //   //         tempError =
        //             //   //           tempError.length == 0
        //             //   //             ? this.contents.data.modal.fields[index]
        //             //   //                 .fields[i].name
        //             //   //             : tempError;
        //             //   //       }
        //             //   //       break;
        //             //   //     case "isSpace":
        //             //   //       this.contents.data.modal.fields[index].fields[
        //             //   //         i
        //             //   //       ].errorCode =
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .validation.length > 1 &&
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].errorCode
        //             //   //           : String(
        //             //   //               obj[
        //             //   //                 this.contents.data.modal.fields[index]
        //             //   //                   .name
        //             //   //               ][p][
        //             //   //                 this.contents.data.modal.fields[index]
        //             //   //                   .fields[i].name
        //             //   //               ]
        //             //   //             ).trim().length == 0
        //             //   //           ? this.contents.data.modal.fields[index].fields[
        //             //   //               i
        //             //   //             ].validation[expression].id
        //             //   //           : 0;
        //             //   //       if (
        //             //   //         this.contents.data.modal.fields[index].fields[i]
        //             //   //           .errorCode > 0
        //             //   //       ) {
        //             //   //         errorCount += 1;
        //             //   //         tempError =
        //             //   //           tempError.length == 0
        //             //   //             ? this.contents.data.modal.fields[index]
        //             //   //                 .fields[i].name
        //             //   //             : tempError;
        //             //   //       }
        //             //   //       break;
        //             //   //     default:
        //             //   //       this.contents.data.modal.fields[
        //             //   //         index
        //             //   //       ].errorCode = 0;
        //             //   //       break;
        //             //   //   }
        //             //   // }
        //             // }
        //           }
        //         }
        //       } else {
        //         if (this.contents.data.modal.fields[index].fields[i].required) {
        //           for (let expression in this.contents.data.modal.fields[index]
        //             .fields[i].validation) {
        //             switch (
        //               this.contents.data.modal.fields[index].fields[i]
        //                 .validation[expression].expression
        //             ) {
        //               case "isEmpty":
        //                 this.contents.data.modal.fields[index].fields[
        //                   i
        //                 ].errorCode =
        //                   !obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i]
        //                       .name
        //                   ] ||
        //                   obj[this.contents.data.modal.fields[index].name][p][
        //                     this.contents.data.modal.fields[index].fields[i]
        //                       .name
        //                   ].length == 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .validation[expression].id
        //                     : 0;
        //                 if (
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                 ) {
        //                   errorCount += 1;
        //                   tempError =
        //                     tempError.length == 0
        //                       ? this.contents.data.modal.fields[index].fields[i]
        //                           .name
        //                       : tempError;
        //                 }
        //                 break;
        //               case "isSpace":
        //                 this.contents.data.modal.fields[index].fields[
        //                   i
        //                 ].errorCode =
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .validation.length > 1 &&
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .errorCode
        //                     : String(
        //                         obj[
        //                           this.contents.data.modal.fields[index].name
        //                         ][p][
        //                           this.contents.data.modal.fields[index].fields[
        //                             i
        //                           ].name
        //                         ]
        //                       ).trim().length == 0
        //                     ? this.contents.data.modal.fields[index].fields[i]
        //                         .validation[expression].id
        //                     : 0;
        //                 if (
        //                   this.contents.data.modal.fields[index].fields[i]
        //                     .errorCode > 0
        //                 ) {
        //                   errorCount += 1;
        //                   tempError =
        //                     tempError.length == 0
        //                       ? this.contents.data.modal.fields[index].fields[i]
        //                           .name
        //                       : tempError;
        //                 }
        //                 break;
        //               default:
        //                 this.contents.data.modal.fields[index].errorCode = 0;
        //                 break;
        //             }
        //           }
        //         }
        //       }
        //     }
        //   }
        // } else {
        if (this.contents.data.modal.fields[index].required) {
          for (let expression in this.contents.data.modal.fields[index]
            .validation) {
            switch (
              this.contents.data.modal.fields[index].validation[expression]
                .expression
            ) {
              case 'isEmpty':
                this.contents.data.modal.fields[index].errorCode =
                  !obj[this.contents.data.modal.fields[index].name] ||
                  obj[this.contents.data.modal.fields[index].name].length == 0
                    ? this.contents.data.modal.fields[index].validation[
                        expression
                      ].id
                    : 0;
                if (this.contents.data.modal.fields[index].errorCode > 0) {
                  errorCount += 1;
                  tempError =
                    tempError.length == 0
                      ? this.contents.data.modal.fields[index].name
                      : tempError;
                }
                break;
              case 'isSpace':
                this.contents.data.modal.fields[index].errorCode =
                  this.contents.data.modal.fields[index].validation.length >
                    1 && this.contents.data.modal.fields[index].errorCode > 0
                    ? this.contents.data.modal.fields[index].errorCode
                    : String(
                        obj[this.contents.data.modal.fields[index].name]
                      ).trim().length == 0
                    ? this.contents.data.modal.fields[index].validation[
                        expression
                      ].id
                    : 0;
                if (this.contents.data.modal.fields[index].errorCode > 0) {
                  errorCount += 1;
                  tempError =
                    tempError.length == 0
                      ? this.contents.data.modal.fields[index].name
                      : tempError;
                }
                break;
              default:
                this.contents.data.modal.fields[index].errorCode = 0;
                break;
            }
          }
        }
        // }
      }
      this.firstErrorName =
        tempError.length > 0 ? tempError : this.firstErrorName;
      return errorCount == 0 ? true : false;
    },
    inputValidation_new(obj) {
      let errorCount = 0;
      let tempItem = {};

      let tempStep = this.contents.data.modal.fields;
      for (let i in tempStep) {
        if (
          tempStep[i].type == 'tab' ||
          tempStep[i].type == 'radioTab' ||
          tempStep[i].type == 'imgRadio' ||
          tempStep[i].type == 'mulImgRadio'
        ) {
          tempItem = tempStep[i].tabs[this.registerInfo[tempStep[i].key]].rows;
        } else {
          tempItem = tempStep;
        }
      }
      for (let i in tempItem) {
        if (tempItem[i].required) {
          for (let v in tempItem[i].validation) {
            switch (tempItem[i].validation[v].expression) {
              case 'isEmpty':
                tempItem[i].errorCode =
                  !obj[tempItem[i].key] || obj[tempItem[i].key].length == 0
                    ? tempItem[i].validation[v].id
                    : 0;
                if (tempItem[i].errorCode > 0) {
                  errorCount += 1;
                }
                tempItem[i].type == 'selectMiniFile'
                  ? null
                  : this.goto(tempItem[i].name);
                break;
              case 'isSpace':
                tempItem[i].errorCode =
                  tempItem[i].validation.length > 1 && tempItem[i].errorCode > 0
                    ? tempItem[i].errorCode
                    : String(obj[tempItem[i].name]).trim().length == 0
                    ? tempItem[i].validation[v].id
                    : 0;
                if (tempItem[i].errorCode > 0) {
                  errorCount += 1;
                }
                this.goto(tempItem[i].name);
                break;
              default:
                tempItem[i].errorCode = 0;
                break;
            }
          }
        }
      }
      return errorCount == 0 ? true : false;
    },
    createPosts(obj) {
      let data = {
        endPoint: `posts`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          photos: obj['postPhoto'],
          title: obj['postTitle'],
          description: obj['postDescription'],
          tags: obj['postTags'],
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.resetPostInfo();
          this.readPosts();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.$store.commit('setLoader', false);
        });
    },
    readPosts(page) {
      let data = {
        endPoint: `posts`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          res.data.data.length > 0
            ? (this.dataIsEmpty = false)
            : (this.dataIsEmpty = true);
          this.posts = res.data.data;
          this.posts = this.posts.reverse();
          for (let i in this.posts) {
            this.posts[i].postDate = new Date(
              this.posts[i].postDate
            ).toLocaleDateString(this.routeLocale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            });
            this.posts[i].postPhoto = this.posts[i].postPhoto.split(",")
            console.log(this.posts[i].postPhoto)
          }
          if (page == 1) {
            this.totalPages = res.data.totalRes;
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[1] = true;
          this.loaderDone();
        });
    },
    readCategories() {
      let data = {
        endPoint: `categories`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          let tempCategories = this.contents.data.modal.fields[4];
          for (let tag in res.data.data) {
            tempCategories.options.push({
              title: res.data.data[tag].categoryName,
              value: res.data.data[tag].id,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    readTags() {
      let data = {
        endPoint: `tags`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          let tempTags = this.contents.data.modal.fields[3];
          for (let tag in res.data.data) {
            tempTags.options.push({
              title: res.data.data[tag].tagName,
              value: res.data.data[tag].id,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.loaderStatus[2] = true;
          this.loaderDone();
        });
    },
    updatePosts(obj) {
      let data = {
        endPoint: `posts/u/${obj.id}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          title: obj['postTitle'],
          description: obj['postDescription'],
          photos: obj['postPhoto'],
          tags: obj['postTags'],
          status: obj['postStatus'],
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.resetPostInfo();
          this.readPosts();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.$store.commit('setLoader', false);
        });
    },
    deletePosts(obj) {
      this.$store.commit('setLoader', true);

      let data = {
        endPoint: `posts/d/${obj.id}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.resetPostInfo();
          this.readPosts();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.$store.commit('setLoader', false);
        });
    },
    goto() {
      // console.log(this.$refs[refName])
      // this.$refs[refName][0].scrollIntoView({ behavior: "smooth" });
    },
  },
  mounted() {
    this.$store.commit('setLoader', true);
    this.getContents();
    this.readPosts(1);
  },
};
</script>
